import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import usersReducer from './usersReducer'
import contentsReducer from './contentsReducer'
import rollcallReducer from './rollcallReducer'

export default combineReducers({
  auth: authReducer,
  users:usersReducer,
  contents:contentsReducer,
  rollcalls:rollcallReducer,
  errors: errorReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js